export default "__VITE_ASSET__CPILNMPA__"